import { useContext } from 'react';
import { AuthContext } from '../providers/AuthProvider';

/** Devuelve { perfilActivo, setPerfilActivo, perfiles } del contexto de auth. */
export default function usePerfilActivo() {
  const ctx = useContext(AuthContext);
  return {
    perfilActivo: ctx?.perfilActivo ?? null,
    setPerfilActivo: ctx?.setPerfilActivo ?? (() => {}),
    perfiles: ctx?.user?.perfiles ?? [],
  };
}
